import React, { useState } from "react";
import { UserMinus } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "../../components/reusableComponents/Dialog";
import { apiErrorMessage } from "../../utils/apiError";

export default function RetireContactButton({ contact, disabled, onConfirm }) {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState("");
  const [pending, setPending] = useState(false);
  const name = [contact.firstname, contact.lastname].filter(Boolean).join(" ") || "ce contact";
  const busy = pending || disabled;
  const confirm = async () => {
    if (busy) return;
    setPending(true);
    setError("");
    try {
      await onConfirm();
      setOpen(false);
    } catch (failure) {
      setError(apiErrorMessage(failure, "Le contact n’a pas pu être retiré. Réessayez."));
    } finally {
      setPending(false);
    }
  };
  return <>
    <button type="button" disabled={disabled || contact.active === false} onClick={() => { setError(""); setOpen(true); }}
      aria-label={`Retirer ${name}`} className="inline-flex items-center gap-1.5 rounded-lg px-2 py-2 text-sm font-medium text-red-600 hover:bg-red-50 disabled:opacity-40">
      <UserMinus className="h-4 w-4" aria-hidden="true" />Retirer
    </button>
    <Dialog open={open} onOpenChange={value => { if (!busy) setOpen(value); }}>
      <DialogContent className="max-w-md rounded-xl">
        <div className="space-y-4 p-6">
          <DialogTitle>Retirer {name} ?</DialogTitle>
          <DialogDescription>Ce contact sortira de la liste active et ne sera plus proposé pour les nouveaux documents. Vous pourrez retrouver son historique en affichant les contacts partis.</DialogDescription>
          {error && <p role="alert" className="text-sm text-red-700">{error}</p>}
          <div className="flex justify-end gap-3">
            <button type="button" disabled={busy} onClick={() => setOpen(false)} className="rounded-lg border border-slate-200 px-4 py-2 text-sm">Annuler</button>
            <button type="button" disabled={busy} onClick={confirm} className="rounded-lg bg-red-600 px-4 py-2 text-sm font-semibold text-white disabled:opacity-50">{busy ? "Retrait en cours…" : "Confirmer le retrait"}</button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  </>;
}
